app.controller("alertWindowController", ["$scope", "$http", "FreshModal", "$uibModalInstance", "$uibModal",
    function ($scope, $http, FreshModal, $uibModalInstance, $uibModal) {

        $scope.close = function () {
            $uibModalInstance.dismiss();
        };

        $scope.agree = function () {
            $uibModalInstance.dismiss();
            $uibModal.open({
                controller: "ChangeImageController",
                templateUrl: _pb + 'parameters/changeImage.html',
                size: "md",
                backdrop: 'static',
            }).result
                .then(function (result) {

                }, function () {
                });
        };

        $scope.goChange = function (subject, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            FreshModal.open({
                controller: "ChangeImageController",
                templateUrl: _pb + 'student-new/change-image-window.html',
                resolve: {}
            }).then(function (result) {

            });
            $scope.close();
        }
    }
]);
